/**
 * routes/index.ts
 *
 * Portal-wide route tree.
 *
 * Each app's route subtree is composed here along with shared top-level nodes
 * (root, app) into a single `routes` object.
 */

import AppsIcon from '@mui/icons-material/Apps';

import { engagementLetterDatabaseRoutes } from '@/apps/engagement-letter-database/routes';

const seg: Record<string, string> = {
  app: 'app',
};

export const routes = {
  root: {
    segment: '',
    path: '/',
    label: 'Client Matter Administration Portal',
    icon: AppsIcon,
  },

  engagementLetterDatabase: engagementLetterDatabaseRoutes,

  app: {
    segment: seg.app,
    path: `/${seg.app}`,
    label: 'App',
    icon: AppsIcon,
  },
};

export type RouteTree = typeof routes;
